import { PathItemElement } from '@swagger-api/apidom-ns-openapi-3-1';
/**
 * @public
 */
class PathItem extends PathItemElement {
  /**
   * OpenAPI 3.2: QUERY operation support.
   * Allows query operations with request bodies.
   */
  get QUERY() {
    return this.get('query');
  }
  set QUERY(operation) {
    this.set('query', operation);
  }

  /**
   * OpenAPI 3.2: Additional operations beyond standard HTTP methods.
   */
  get additionalOperations() {
    return this.get('additionalOperations');
  }
  set additionalOperations(operations) {
    this.set('additionalOperations', operations);
  }
}
export default PathItem;